/// <summary>
/// This visual provides a list of user comments<br/>
/// </summary>  
/// <remarks>
/// Author: MKU<br/>
/// Date: 21.05.2026<br/>
/// Copyright ©: EUDT GmbH 2024 <br/>
/// Version-History:<br/>
/// **********************************************************************<br/>
/// *** v1.0.0 - 21.05.2026                                            ***<br/>
/// *--------------------------------------------------------------------*<br/>
/// *** v1.0.1 - 25.06.2026 - MKU                                      ***<br/>
/// * - Added "icon-color-ok" to unread messages divider for green styling *<br/>
/// * - Removed trailing commas to fix Bundler & Minifier syntax errors  *<br/>
/// **********************************************************************<br/>
jQuery.widget("bluaul.UserNotificationComments", jQuery.common.vcBaseV4, {

    sendEmailType: 0, // 0 = kein Email, 1 = nur intern, 2 = alle


    _create: function () {
        this._createVisual(403);
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {
            me._setRoot(".vc-user-notification-comments");
            me.myStatus = me.myStatus || {};
            me.myStatus.editId = null;   // id of the comment currently being edited, or null
            me.myStatus.replyId = null;   // flag – true when in reply mode
            me._buildHtml();
            me._initMarkedUsersDropdown();
            // flag: first fetch should silently mark as read in DB after rendering
            me._markReadAfterFetch = true;
            me._fetch();
        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {
            // vcFilter for text searching – filters bubble rows based on author name and message text
            me.myHtml.header.topmenu.filter.vcFilter({ callback: function () { me._filterBubbles(); } });

            // we hide the search filter by default and only show it when the search icon is clicked, to keep the UI clean. This is a bit unorthodox but works well for this use case.
            me.myHtml.header.topmenu.hide();

            me.myHtml.header.topmenu.filter.off("click").on("click", function () {
                $(this).find("input").focus();
            });

            // show/hide filter on search icon click
            me.myHtml.header.btnSearch.off("click").on("click", function () {
                me.myHtml.header.topmenu.slideToggle(150);
            });

            // send / update button
            me.myHtml.inputArea.btnSend.off("click").on("click", function () { me._sendComment(); });

            // cancel edit button
            me.myHtml.inputArea.btnCancelEdit.off("click").on("click", function () { me._cancelEditMode(); });

            // cancel reply button
            me.myHtml.inputArea.btnCancelReply.off("click").on("click", function () { me._cancelReplyMode(); });

            // send on Ctrl+Enter
            me.myHtml.inputArea.txtComment.off("keydown").on("keydown", function (e) {
                if (e.ctrlKey && e.which === 13) {
                    e.preventDefault();
                    me._sendComment();
                }
                if (e.which === 27 && me.myStatus.editId !== null) {
                    me._cancelEditMode();
                }
            });

            // enable/disable send button depending on input
            me.myHtml.inputArea.txtComment.off("input").on("input", function () { me._updateSendButtonStatus(); });

            // bubble action buttons – delegated on the history container
            me.myHtml.history.off("click", ".uncc-action-edit").on("click", ".uncc-action-edit", function () {
                var row = $(this).closest(".uncc-bubble-row");
                me._onEditComment(parseInt(row.attr("data-id"), 10), row.find(".uncc-bubble-text").text());
            });

            me.myHtml.history.off("click", ".uncc-action-delete").on("click", ".uncc-action-delete", function () {
                me._onDeleteComment(parseInt($(this).closest(".uncc-bubble-row").attr("data-id"), 10));
            });

            me.myHtml.history.off("click", ".uncc-action-reply").on("click", ".uncc-action-reply", function () {
                var row = $(this).closest(".uncc-bubble-row");
                me._onReplyComment(parseInt(row.attr("data-id"), 10), row.attr("data-author"));
            });

            // hover and active color toggling for action icons using global utility classes
            me.myHtml.history.off("mouseenter mousedown", ".vc-list-icon").on("mouseenter mousedown", ".vc-list-icon", function () {
                $(this).removeClass("icon-color-info icon-color-error").addClass("icon-color-ok");
            });

            me.myHtml.history.off("mouseleave mouseup", ".vc-list-icon").on("mouseleave mouseup", ".vc-list-icon", function () {
                var icon = $(this);
                icon.removeClass("icon-color-ok");

                // restore original color class based on the icon's action
                if (icon.hasClass("uncc-action-delete")) {
                    icon.addClass("icon-color-error");
                } else {
                    icon.addClass("icon-color-info");
                }
            });


        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _getTypeConfig: function (typeId) {
        /// <summary>
        /// Returns the configuration for a given typeId, including name and icon.
        /// </summary>
        var types = {
            1: { name: "Ticket", icon: "fa-regular fa-ticket" },
            2: { name: "Signal", icon: "fa-regular fa-bolt" }
        };
        return types[typeId] || { name: "Eintrag", icon: "fa-regular fa-file" };
    },

    _buildHtml: function () {
        /// <summary>
        /// This function builds the html structure
        /// </summary>
        var me = this;
        try {
            me.myHtml = { header: { topmenu: {} }, history: {}, inputArea: {} };

            // ---- header ----
            me.myHtml.header = me._setObj("div-comments-header", "uncc-header");
            me.myHtml.header.divTitle = me._setObj("div-comments-title", "uncc-title vc-grid-margin-bottom");

            var assignId = parseInt(me.specific.assignId, 10);
            var assignTypeId = parseInt(me.specific.assignTypeId, 10) || 1;
            var typeConfig = me._getTypeConfig(assignTypeId);

            var titleTextSpan = $("<span>").addClass("uncc-title-text");
            if (assignId > 0) {
                var iconHtml = "<i class='" + typeConfig.icon + "' style='margin-right: 8px;'></i>";
                var titleText = typeConfig.name + " " + assignId + " \u2013 " + (me.specific.resources.comments);
                titleTextSpan.html(iconHtml + $("<span>").text(titleText).html());
            } else {
                titleTextSpan.text(me.specific.resources.comments);
            }
            me.myHtml.header.divTitle.append(titleTextSpan);

            // search icon
            me.myHtml.header.btnSearch = $("<i>").addClass("fa fa-search uncc-btn-search").attr("title", me.specific.resources.search);
            me.myHtml.header.divTitle.append(me.myHtml.header.btnSearch);

            me.myHtml.header.append(me.myHtml.header.divTitle);

            // ---- top menu: vcFilter ----
            me.myHtml.header.topmenu = me._setObj("div-comments-topmenu", "uncc-topmenu");
            var tm = me.myHtml.header.topmenu;

            tm.filterWrap = me._setObj("div-comments-filter-wrap", "uncc-filter-wrap");
            tm.filter = me._setObj("div-comments-filter", "vc-filter uncc-filter");
            tm.filterWrap.append(tm.filter);
            tm.append(tm.filterWrap);
            me.myHtml.header.append(me.myHtml.header.topmenu);

            var hr = $("<hr>").addClass("uncc-topmenu-hr");
            me.myHtml.header.append(hr);

            // ---- chat history ----
            me.myHtml.history = me._setObj("div-comments-history", "uncc-history");

            // ---- input area ----
            me.myHtml.inputArea = me._setObj("div-comments-input", "uncc-input-area");

            // -- edit hint row --
            me.myHtml.inputArea.editHintRow = $("<div>").attr("id", "div-uncc-edit-hint-row").addClass("uncc-edit-hint-row").hide();
            me.myHtml.inputArea.editHint = $("<span>").attr("id", "span-uncc-edit-hint").addClass("uncc-edit-hint");
            me.myHtml.inputArea.btnCancelEdit = me._setObj("btn-comment-cancel-edit", "button-toggle uncc-btn-cancel-edit").html("<i class='fa fa-times'></i> " + (me.specific.resources.cancelEdit)).attr("title", me.specific.resources.cancelEdit).button();
            me.myHtml.inputArea.editHintRow.append(me.myHtml.inputArea.editHint, me.myHtml.inputArea.btnCancelEdit);

            // -- reply hint row --
            me.myHtml.inputArea.replyHintRow = $("<div>").attr("id", "div-uncc-reply-hint-row").addClass("uncc-edit-hint-row").hide();
            me.myHtml.inputArea.replyHint = $("<span>").attr("id", "span-uncc-reply-hint").addClass("uncc-edit-hint");
            me.myHtml.inputArea.btnCancelReply = me._setObj("btn-comment-cancel-reply", "button-toggle uncc-btn-cancel-edit").html("<i class='fa fa-times'></i> " + (me.specific.resources.cancelEdit)).attr("title", me.specific.resources.cancelEdit).button();
            me.myHtml.inputArea.replyHintRow.append(me.myHtml.inputArea.replyHint, me.myHtml.inputArea.btnCancelReply);

            // -- marked users dropdown --
            me.myHtml.inputArea.markedUsersRow = $("<div>").attr("id", "div-uncc-marked-users-row").addClass("uncc-marked-users-row");
            me.myHtml.inputArea.ddlMarkedUsers = $("<select>").attr("id", "ddl-uncc-marked-users").prop("multiple", true);
            me.myHtml.inputArea.markedUsersRow.append(me.myHtml.inputArea.ddlMarkedUsers);

            // -- textarea + send button --
            me.myHtml.inputArea.txtComment = me._setTextArea("area-comment-text", "uncc-textarea").attr({
                placeholder: me.specific.resources.writeComment,
                rows: 3
            });

            me.myHtml.inputArea.btnSend = me._setObj("btn-comment-send", "button-toggle uncc-btn-send").html("<i class='fa fa-paper-plane'></i>").attr("title", me.specific.resources.send).button().button("disable");

            me.myHtml.inputArea.append(
                me.myHtml.inputArea.editHintRow,
                me.myHtml.inputArea.replyHintRow,
                me.myHtml.inputArea.markedUsersRow,
                me.myHtml.inputArea.txtComment,
                me.myHtml.inputArea.btnSend
            );

            me.myRoot.append(me.myHtml.header, me.myHtml.history, me.myHtml.inputArea);


        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _scrollToBottom: function () {
        /// <summary>
        /// Scrolls the history container to the bottom.
        /// </summary>
        var me = this;
        try {
            var el = me.myHtml.history[0];
            if (el) el.scrollTop = el.scrollHeight;
        } catch (e) { me._writeErr(e); }
    },

    _updateSendButtonStatus: function () {
        /// <summary>
        /// Enables or disables the send button based on whether there is text in the input area.
        /// </summary>
        var me = this;
        try {
            var val = (me.myHtml.inputArea.txtComment.val() || "").trim();
            me.myHtml.inputArea.btnSend.button(val.length > 0 ? "enable" : "disable");
        } catch (e) { me._writeErr(e); }
    },


    _initMarkedUsersDropdown: function () {
        ///<summary>
        /// Initializes the marked users dropdown using Selectize.js. Fetches the list of users from the server and populates the dropdown.
        ///</summary>
        var me = this;
        try {
            me.getData({ TypeId: 2 }, function (result) {

                if (!result || !Array.isArray(result.rows)) return;

                var ddlEl = me.myHtml.inputArea.ddlMarkedUsers;

                // destroy existing instance if any
                if (ddlEl[0] && ddlEl[0].selectize) { ddlEl[0].selectize.destroy(); }

                // re-create as proper <select multiple> and replace in DOM
                var newSelect = $("<select>").attr("id", "ddl-uncc-marked-users").prop("multiple", true);
                ddlEl.replaceWith(newSelect);
                me.myHtml.inputArea.ddlMarkedUsers = newSelect;
                ddlEl = newSelect;

                var items = result.rows.map(function (r) {
                    return { Id: r.id, Name: r.name };
                });

                ddlEl.selectize({
                    create: false,
                    maxItems: null,
                    valueField: "Id",
                    labelField: "Name",
                    searchField: "Name",
                    options: items,
                    plugins: ["remove_button"],
                    dropdownParent: "body",
                    placeholder: me.specific.resources.markUsers,
                    render: {
                        option: function (item, escape) {
                            return "<div class='option'><i class='fa fa-at'></i> " + escape(item.Name) + "</div>";
                        },
                        item: function (item, escape) {
                            return "<div class='item'><i class='fa fa-at'></i> " + escape(item.Name) + "</div>";
                        }
                    }
                });

                me.ddlMarkedUsers = ddlEl[0].selectize;
            });
        } catch (e) { me._writeErr(e); }
    },

    _getMarkedUserIds: function () {
        /// <summary>
        /// This function returns an array of user IDs that are currently selected in the marked users dropdown.
        /// </summary>
        var me = this;
        try {
            if (!me.ddlMarkedUsers) return [];
            return me.ddlMarkedUsers.items.map(function (v) { return parseInt(v, 10); });
        } catch (e) { me._writeErr(e); return []; }
    },

    _clearMarkedUsers: function () {
        ///<summary>
        /// Clears the marked users dropdown selection.
        ///</summary>
        var me = this;
        try { if (me.ddlMarkedUsers) me.ddlMarkedUsers.clear(true); } catch (e) { }
    },

    // =====================================================================
    // EDIT MODE
    // =====================================================================

    _enterEditMode: function (id, currentText) {
        /// <summary>
        /// Switches the input area into edit mode: loads existing text, shows cancel button and hint.
        /// </summary>
        var me = this;
        try {
            me.myStatus.editId = id;

            me.myHtml.inputArea.editHint.addClass("icon-color-error").html("<i class='fa fa-pencil'></i> " + (me.specific.resources.edit));

            me.myHtml.inputArea.editHintRow.show();
            me.myHtml.inputArea.txtComment.val(currentText).focus();

            me.myHtml.inputArea.addClass("uncc-input-area-edit icon-color-error");

            me._updateSendButtonStatus();

            var el = me.myHtml.inputArea.txtComment[0];
            if (el) { el.selectionStart = el.selectionEnd = el.value.length; }
        } catch (e) { me._writeErr(e); }
    },

    _cancelEditMode: function () {
        /// <summary>
        /// Resets the input area back to normal insert mode.
        /// </summary>
        var me = this;
        try {
            me.myStatus.editId = null;
            me.myHtml.inputArea.txtComment.val("").focus();
            me.myHtml.inputArea.editHint.removeClass("icon-color-error");
            me.myHtml.inputArea.editHintRow.hide();
            me.myHtml.inputArea.removeClass("uncc-input-area-edit icon-color-error");
            if (me.ddlMarkedUsers) me.ddlMarkedUsers.clear(true);
            me._updateSendButtonStatus();
        } catch (e) { me._writeErr(e); }
    },

    // =====================================================================
    // REPLY MODE
    // =====================================================================

    _enterReplyMode: function (authorName, quotePrefix) {
        var me = this;
        try {
            me.myStatus.replyId = true; // flag – we are in reply mode
            me.myHtml.inputArea.replyHint.addClass("icon-color-info").html("<i class='fa fa-reply'></i> " + (me.specific.resources.reply) + ": <strong>" + $("<span>").text(authorName).html() + "</strong>");
            me.myHtml.inputArea.replyHintRow.show();
            me.myHtml.inputArea.txtComment.val(quotePrefix).focus();
            me.myHtml.inputArea.addClass("uncc-input-area-reply icon-color-info");
            me._updateSendButtonStatus();
            var el = me.myHtml.inputArea.txtComment[0];
            if (el) { el.selectionStart = el.selectionEnd = quotePrefix.length; }
        } catch (e) { me._writeErr(e); }
    },

    _cancelReplyMode: function () {
        var me = this;
        try {
            me.myStatus.replyId = null;
            me.myHtml.inputArea.txtComment.val("").focus();
            me.myHtml.inputArea.replyHint.removeClass("icon-color-info");
            me.myHtml.inputArea.replyHintRow.hide();
            me.myHtml.inputArea.removeClass("uncc-input-area-reply icon-color-info");
            if (me.ddlMarkedUsers) me.ddlMarkedUsers.clear(true);
            me._updateSendButtonStatus();
        } catch (e) { me._writeErr(e); }
    },

    // =====================================================================
    // SEND / UPDATE
    // =====================================================================

    _markAllReadAndRefresh: function () {
        /// <summary>
        /// Marks all comments as read in the DB, then re-fetches so unread styling disappears.
        /// Called on any user interaction (send, reply, edit, delete).
        /// </summary>
        var me = this;
        try {
            me.updateData({ TypeId: 4, AssignId: parseInt(me.specific.assignId, 10) || -1 }, function (result) {
                if (result && result.Success) {
                    me._fetch();
                    // notify parent widgets (CommentList → Center) to refresh unread counts
                    me.element.trigger("notificationRead");
                }
            });
        } catch (e) { me._writeErr(e); }
    },

    _openEmailDialog: function (comment) {
        var me = this;
        try {
            // We render the confirm UI directly inside me.visual (guaranteed to be
            // inside the Comments popup opened by Ticket.js with z-index 10500).
            // Any jQuery UI dialog approach fails because the Comments popup uses
            // modal:false with a manually forced z-index that jQuery UI doesn't track.

            // remove any previous instance
            me.visual.find(".uncc-email-background").remove();
            me.visual.find(".uncc-email-overlay").remove();

            var background = $("<div>").addClass("uncc-email-background").css({ background: "white", position: "absolute", top: 0, left: 0, right: 0, bottom: 0, opacity: 0.75, zIndex: 9998, height: "100%", width: "100%" });
            var overlay = $("<div>").addClass("uncc-email-overlay").css({ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, background: "transparent", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" });
            var box = $("<div>").addClass("uncc-email-box saveDialog").css({ background: "#fff", borderRadius: "0px", padding: "10px 10px", minWidth: "300px", minHeight: "130px", maxWidth: "90%" });

            var title = $("<div>").css({ fontWeight: "bold", marginBottom: "12px", fontSize: "1em" }).text(me.specific.resources.validation);
            var msg = $("<div>").css({ marginBottom: "55px" }).text(me.specific.resources.notifyUsers);
            var btnRow = $("<div>").css({ display: "flex", gap: "5px", justifyContent: "right", marginRight: "5px", flexWrap: "wrap" });

            var btnNo = $("<div>").addClass("button-toggle").text(me.resources.no).button();
            var btnIntern = $("<div>").addClass("button-toggle").text(me.specific.resources.internalOnly).button();
            var btnAll = $("<div>").addClass("button-toggle").text(me.specific.resources.toAll).button();

            btnNo.on("click", function () { background.remove(); overlay.remove(); me.sendEmailType = 0; me._doSendComment(comment); });
            btnIntern.on("click", function () { background.remove(); overlay.remove(); me.sendEmailType = 1; me._doSendComment(comment); });
            btnAll.on("click", function () { background.remove(); overlay.remove(); me.sendEmailType = 2; me._doSendComment(comment); });

            btnRow.append(btnNo, btnIntern, btnAll);
            box.append(title, msg, btnRow);
            overlay.append(box);

            // ensure the visual container has position:relative so the absolute overlay works
            me.visual.css("position", "relative");
            me.visual.append(background, overlay);

            return true;
        } catch (e) { me._writeErr(e); return false; }
    },

    _sendComment: function () {
        var me = this;
        try {
            var comment = (me.myHtml.inputArea.txtComment.val() || "").trim();
            if (!comment.length) return;

            // we check if the user is staff or admin to decide whether to show the email dialog or send directly
            var isStaff = me.specific.isStaff === true || me.specific.isStaff === "true";
            var isAdmin = me.specific.isAdmin === true || me.specific.isAdmin === "true";
            var isStaffOrAdmin = isStaff || isAdmin;

            if (isStaffOrAdmin) {
                // staff/admin: show dialog to choose email type (none, internal, all)
                me._openEmailDialog(comment);
            } else {
                // customer: send directly with external email type
                me.sendEmailType = 2;
                me._doSendComment(comment);
            }
        } catch (e) { me._writeErr(e); }
    },


    _doSendComment: function (text) {
        /// <summary>
        /// Sends the comment to the server, either as a new comment or an update if in edit mode.
        /// </summary>
        var me = this;
        try {
            var isEdit = me.myStatus.editId !== null;
            var typeId = isEdit ? 2 : 1;
            var payload = {
                TypeId: typeId,
                Text: text,
                MarkedUserIds: me._getMarkedUserIds(),
                SendEmailType: me.sendEmailType,
                AssignId: parseInt(me.specific.assignId, 10) || -1
            };
            if (isEdit) payload.Id = me.myStatus.editId;

            me.myHtml.inputArea.btnSend.button("disable");
            me.myHtml.inputArea.txtComment.prop("disabled", true);

            me.updateData(payload, function (result) {
                me.myHtml.inputArea.txtComment.prop("disabled", false).val("");
                if (me.ddlMarkedUsers) me.ddlMarkedUsers.clear(true);
                me._cancelEditMode();
                me._cancelReplyMode();
                me._updateSendButtonStatus();
                if (result && result.Success) {
                    me._markAllReadAndRefresh(); // after interaction - mark all as read
                }
            });
        } catch (e) { me._writeErr(e); }
    },



    _fetch: function () {
        /// <summary>
        /// Fetches the comment history from the server and renders it. Shows a loading indicator while fetching.
        /// </summary>
        var me = this;
        try {
            var limit = -1;
            var loadingWrap = $("<div>").addClass("uncc-loading-wrap").html(me.getLoadingIcon());
            me.myHtml.history.empty().append(loadingWrap);

            me.getData({ TypeId: 1, Limit: limit, AssignId: parseInt(me.specific.assignId, 10) || -1 }, function (result) {
                if (!result || !Array.isArray(result)) {
                    me.myHtml.history.html($("<div>").addClass("note").text(me.resources.noEntriesExist));
                    return;
                }
                me._renderHistory(result);

                if (me._markReadAfterFetch) {
                    me._markReadAfterFetch = false;
                    me.updateData({ TypeId: 4, AssignId: parseInt(me.specific.assignId, 10) || -1 }, function () {
                        // notify parent widgets to refresh unread counts
                        me.element.trigger("notificationRead");
                    });
                }
            });
        } catch (e) { me._writeErr(e); }
    },

    _renderHistory: function (rows) {
        /// <summary>
        /// Takes an array of comment rows and renders them into the history container. Inserts a divider before the first unread message.
        /// </summary>
        var me = this;
        try {
            var history = me.myHtml.history;
            history.empty();

            if (!rows.length) {
                history.html($("<div>").addClass("note").text(me.resources.noEntriesExist));
                return;
            }

            // count unread
            var unreadCount = rows.filter(function (r) {
                return r.IsRead === false && r.IsDeleted !== true;
            }).length;

            var dividerInserted = false;

            rows.forEach(function (r) {
                // insert divider before first unread message
                if (!dividerInserted && r.IsRead === false && r.IsDeleted !== true && unreadCount > 0) {
                    var label = unreadCount + " " + (me.specific.resources.unreadMessages);

                    // Added "icon-color-ok" utility class to style the unread divider with the brand's green color
                    var divider = $("<div>").addClass("uncc-unread-divider icon-color-ok").html("<span class='uncc-unread-divider-line'></span>" + "<span class='uncc-unread-divider-label'>" + label + "</span>" + "<span class='uncc-unread-divider-line'></span>");
                    history.append(divider);
                    dividerInserted = true;
                }
                history.append(me._buildBubble(r));
            });

            // scroll to the divider (first unread), not to the bottom
            if (dividerInserted) {
                var dividerEl = history.find(".uncc-unread-divider")[0];
                if (dividerEl) {
                    history[0].scrollTop = dividerEl.offsetTop - 10;
                }
            } else {
                me._scrollToBottom();
            }

        } catch (e) { me._writeErr(e); }
    },

    _buildBubble: function (r) {
        /// <summary>
        /// Builds one full bubble row.
        /// Detects a leading quote line ("> Author: text") and renders it as a visual quote block.
        /// </summary>
        var me = this;
        try {
            var isOwn = r.IsOwn === true;
            var isDel = r.IsDeleted === true;
            var isEdit = r.IsEdited === true;
            var isRead = r.IsRead === true;

            var row = $("<div>")
                .addClass("uncc-bubble-row " + (isOwn ? "uncc-own" : "uncc-other"))
                .attr("data-id", r.Id || "")
                .attr("data-author", r.AuthorName || "")
                .attr("data-text", r.Text || "")
                .attr("data-filter", (r.AuthorName || "") + " " + (r.Text || ""))
                .attr("data-marked-user-ids", (Array.isArray(r.MarkedUserIds) && r.MarkedUserIds.length > 0) ? r.MarkedUserIds.join(",") : "");

            var isMentioned = !isDel && Array.isArray(r.MarkedUserIds) && r.MarkedUserIds.indexOf(me.specific.uid) > -1;

            // Create wrapper container for header and bubble
            var wrap = $("<div>").addClass("uncc-bubble-wrap");

            var bubble = $("<div>").addClass("uncc-bubble " + (isOwn ? "tblRow" : "tblRowAlt") + (isDel ? " uncc-bubble-deleted" : "") + (!isRead && !isDel ? " uncc-bubble-unread icon-color-secondary" : "") + (isMentioned ? " uncc-bubble-mentioned icon-color-ok" : ""));

            // ---- author row ----
            var authorRow = $("<div>").addClass("uncc-bubble-header");
            var authorName = $("<span>").addClass("uncc-bubble-author").text(r.AuthorName || "");
            authorRow.append(authorName);

            if (!isDel) {
                var actions = $("<span>").addClass("uncc-bubble-actions");

                // Added icon-color-info class for dark blue styling
                var btnReply = $("<i>").addClass("fa fa-reply uncc-action-reply vc-list-icon icon-color-info").attr("title", me.specific.resources.reply);
                actions.append(btnReply);

                if (isOwn) {
                    actions.append(
                        // Added icon-color-info for dark blue and icon-color-error for red styling
                        $("<i>").addClass("fa fa-pencil uncc-action-edit vc-list-icon icon-color-info").attr("title", me.specific.resources.edit),
                        $("<i>").addClass("fa fa-trash uncc-action-delete vc-list-icon icon-color-error").attr("title", me.specific.resources.delete)
                    );
                }
                authorRow.append(actions);
            }

            // ---- message text ----
            var textEl;
            if (isDel) {
                textEl = $("<div>").addClass("uncc-bubble-text uncc-bubble-text-deleted").html("<i class='fa fa-ban'></i> " + (me.specific.resources.messageDeleted));
            } else {
                textEl = $("<div>").addClass("uncc-bubble-text");

                // @mentions block
                if (Array.isArray(r.MarkedUserNames) && r.MarkedUserNames.length > 0) {
                    var mentionsText = r.MarkedUserNames.map(function (n) { return "@" + n; }).join(" ");
                    var mentionsEl = $("<div>").addClass("uncc-bubble-mentions color-font-secondary").text(mentionsText);
                    textEl.append(mentionsEl);
                }

                var rawText = r.Text || "";
                var quoteText = "";
                var replyText = rawText;

                // collect all leading lines starting with "> " as quote block
                if (rawText.indexOf("> ") === 0) {
                    var lines = rawText.split("\n");
                    var quoteLines = [];
                    var bodyStart = lines.length;
                    for (var qi = 0; qi < lines.length; qi++) {
                        if (lines[qi].indexOf("> ") === 0) {
                            quoteLines.push(lines[qi].substring(2));
                        } else {
                            bodyStart = qi;
                            break;
                        }
                    }
                    quoteText = quoteLines.join("\n");
                    replyText = lines.slice(bodyStart).join("\n").replace(/^\n+/, "");
                }

                if (quoteText.length > 0) {
                    textEl.append($("<div>").addClass("uncc-quote-block")
                        .html("<i class='fa fa-quote-left uncc-quote-icon'></i>" + $("<span>").text(quoteText).prop("outerHTML")));
                }
                if (replyText.length > 0) {
                    textEl.append($("<div>").addClass("uncc-reply-text").text(replyText));
                }
            }

            // ---- meta line ----
            var metaText = r.DateFormatted || "";
            if (isEdit) metaText += " \u00b7 " + (me.specific.resources.edited);

            var meta = $("<div>").addClass("uncc-bubble-meta" + (isEdit ? " uncc-bubble-meta-edited" : "")).text(metaText);

            // Append text and meta directly into the bubble (header/name is excluded)
            bubble.append(textEl, meta);

            // Append header and bubble into the wrapper
            wrap.append(authorRow, bubble);

            // Append wrapper into the row
            row.append(wrap);
            return row;
        } catch (e) { me._writeErr(e); }
    },

    _filterBubbles: function () {
        /// <summary>
        /// Filters bubble rows based on vcFilter tags – searches author name and message text.
        /// </summary>
        var me = this;
        try {
            var tags = me.myHtml.header.topmenu.filter.vcFilter("getFilter");

            me.myHtml.history.find(".uncc-bubble-row").each(function () {
                var row = $(this);
                var haystack = (row.attr("data-filter") || "").toLowerCase();

                if (!tags || tags.length === 0) {
                    row.show();
                    return;
                }

                var allMatch = true;
                for (var i = 0; i < tags.length; i++) {
                    if (haystack.indexOf(tags[i].toLowerCase()) === -1) {
                        allMatch = false;
                        break;
                    }
                }
                row.toggle(allMatch);
            });

            // divider immer sichtbar lassen
            me.myHtml.history.find(".uncc-unread-divider").show();
        } catch (e) { me._writeErr(e); }
    },

    // =====================================================================
    // BUBBLE ACTION HANDLERS
    // =====================================================================

    _onDeleteComment: function (id) {
        var me = this;
        try {
            // We render the confirm UI directly inside me.visual (guaranteed to be
            // inside the Comments popup opened by Ticket.js with z-index 10500).
            // Any jQuery UI dialog approach fails because the Comments popup uses
            // modal:false with a manually forced z-index that jQuery UI doesn't track.

            // remove any previous instance
            me.visual.find(".uncc-delete-background").remove();
            me.visual.find(".uncc-delete-overlay").remove();

            var background = $("<div>").addClass("uncc-delete-background").css({ background: "white", position: "absolute", top: 0, left: 0, right: 0, bottom: 0, opacity: 0.75, zIndex: 9998, height: "100%", width: "100%" });
            var overlay = $("<div>").addClass("uncc-delete-overlay").css({ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, background: "transparent", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" });
            var box = $("<div>").addClass("uncc-delete-box saveDialog").css({ background: "#fff", borderRadius: "0px", padding: "10px 10px", minWidth: "300px", minHeight: "130px", maxWidth: "90%" });

            var title = $("<div>").css({ fontWeight: "bold", marginBottom: "12px", fontSize: "1em" }).text(me.specific.resources.validation);
            var msg = $("<div>").css({ marginBottom: "55px" }).text(me.specific.resources.deleteConfirm);
            var btnRow = $("<div>").css({ display: "flex", gap: "5px", justifyContent: "right", marginRight: "5px", flexWrap: "wrap" });

            var btnNo = $("<div>").addClass("button-toggle").text(me.specific.resources.no).button();
            var btnYes = $("<div>").addClass("button-toggle").text(me.specific.resources.yes).button();

            btnNo.on("click", function () { background.remove(); overlay.remove(); return; });
            btnYes.on("click", function () {
                background.remove(); overlay.remove();
                me.updateData({ TypeId: 3, Id: id }, function (result) {
                    if (result && result.Success) {
                        me._markAllReadAndRefresh(); // if interaction successful - mark all as read
                    }
                });
            });

            btnRow.append(btnYes, btnNo);
            box.append(title, msg, btnRow);
            overlay.append(box);

            // ensure the visual container has position:relative so the absolute overlay works
            me.visual.css("position", "relative");
            me.visual.append(background, overlay);

            return true;
        } catch (e) { me._writeErr(e); return false; }
    },

    _onEditComment: function (id, currentText) {
        var me = this;
        try {
            var row = me.myHtml.history.find(".uncc-bubble-row[data-id='" + id + "']");
            var cleanText = (row.attr("data-text") || "").trim();

            if (me.ddlMarkedUsers) {
                me.ddlMarkedUsers.clear(true);
                var idsRaw = row.attr("data-marked-user-ids") || "";
                if (idsRaw.length > 0) {
                    idsRaw.split(",").forEach(function (idStr) {
                        var uid = parseInt(idStr.trim(), 10);
                        if (!isNaN(uid) && uid > 0) me.ddlMarkedUsers.addItem(String(uid), true);
                    });
                }
            }

            me._enterEditMode(id, cleanText);
        } catch (e) { me._writeErr(e); }
    },

    _onReplyComment: function (id, authorName) {
        /// <summary>
        /// This function is called when the user clicks the reply button on a comment bubble.
        /// </summary>
        var me = this;
        try {
            if (me.myStatus.editId !== null) me._cancelEditMode();
            if (me.myStatus.replyId !== null) me._cancelReplyMode();

            var row = me.myHtml.history.find(".uncc-bubble-row[data-id='" + id + "']");
            var origTxt = (row.attr("data-text") || "").trim();

            // if this message is itself a reply, quote only the reply-text part
            // (the part after the "> Author: ..." line) to avoid nested quoting
            if (origTxt.indexOf("> ") === 0) {
                var lines = origTxt.split("\n");
                var startIdx = 0;
                for (var i = 0; i < lines.length; i++) {
                    if (lines[i].indexOf("> ") !== 0) { startIdx = i; break; }
                }
                origTxt = lines.slice(startIdx).join("\n").replace(/^\n+/, "");
            }

            var maxLen = 100;
            if (origTxt.length > maxLen) origTxt = origTxt.substring(0, maxLen) + "\u2026";

            // prefix each line with "> " so multi-line quotes are fully preserved
            var quotedLines = origTxt.split("\n").map(function (line) { return "> " + line; });
            var quotePrefix = "> " + (authorName || "") + ":\n" + quotedLines.join("\n") + "\n\n";

            me._enterReplyMode(authorName, quotePrefix);
        } catch (e) { me._writeErr(e); }
    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) { }
            return true;
        } catch (e) {
            me.writeError(e); return false;
        }
    }

});